import React from 'react';
import _ from 'lodash';

const Highlighted = ({ text = '', highlight = '', testId }) => {
  if (!highlight.trim()) {
    return <span data-test-id={testId}>{text}</span>;
  }
  const regex = new RegExp(`(${_.escapeRegExp(highlight)})`, 'gi');
  const parts = text.split(regex);
  return (
    <span data-test-id={testId}>
      {parts
        .filter((part) => part)
        .map((part, i) => (regex.test(part) ? <mark key={i}>{part}</mark> : <span key={i}>{part}</span>))}
    </span>
  );
};

export default Highlighted;
